import React, { useState, useEffect } from "react";
import {
  Table,
  Spinner,
  Input,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

import { deviceAllSessionAPI } from "../services/Device";
import { useHistory } from "react-router-dom";
import TableHeader from "components/TableHeader";

const impedanceCache = {
  data: null,
  timestamp: null,
};

const Impadance = () => {
  const history = useHistory();
  const [deviceData, setDeviceData] = useState([]);
  const [searchData, setSearchData] = useState([]);

  const [loading, setLoading] = useState(false);
  const [filterBy, setFilterBy] = useState("SubjectId");
  const [searchValue, setSearchValue] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [sortColumn, setSortColumn] = useState("");
  const [sortOrder, setSortOrder] = useState("");

  //pagination
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 50;

  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = searchData.slice(
    indexOfFirstRecord,
    indexOfLastRecord,
  );
  const totalPages = Math.ceil(searchData.length / recordsPerPage);

  const handleToggle = () => {
    setIsOpen(!isOpen); // Toggle the dropdown's open status
  };
 const refreshlist = () => {
  setLoading(true);
  document.getElementById("refreshbtn").className = "fas fa-sync fa-spin";
  impedanceCache.data = null;  // ← clear cache
  getdata();
};
  const getdata = async () => {
    setLoading(true);
    getAllDevice();
  };
  const applyFilters = () => {
    let filteredList = deviceData;
    if (searchValue) {
      filteredList = deviceData.filter((item) => {
        if (item?.data?.list !== null && filterBy === "SubjectId") {
          
          const subjectId = item?.data?.list?.subjectId?.toLowerCase();
          return subjectId && subjectId.includes(searchValue.toLowerCase());
        }
        return false;
      });
    }
    setSearchData(filteredList);
  };

  const handleFilterByChange = (value) => {
    setSearchValue("");
    setFilterBy(value);
  };

  // Event handler for search input change
  const handleSearchInputChange = (e) => {
    setSearchValue(e.target.value);
  };
  const identifyUsersWithInactiveStim = (deviceData) => {
    const groupedData = deviceData.reduce((groups, item) => {
      const { prcId } = item;
      if (!groups[prcId]) {
        groups[prcId] = [];
      }
      groups[prcId].push(item);
      return groups;
    }, {});

    const usersWithEventErrFvr = Object.entries(groupedData).map(
      ([prcId, data]) => {
        // const filteredData = data.filter(item => item.eventId === 'EVENT_TRT_IMP');
        const filteredData = data;

        if (filteredData.length > 0) {
          const sumData = filteredData.reduce(
            (acc, curr) => acc + parseInt(curr.data || 0),
            0,
          );
          const avgData = (sumData / filteredData.length / 10).toFixed(2);

          return {
            prcId,
            data: {
              list: filteredData[0],
              avgData,
            },
            groupedData,
          };
        } else {
          // If no data found, set avgData to 0
          return {
            prcId,
            data: {
              list: null,
              avgData: 0,
            },
            groupedData,
          };
        }
      },
    );

    return usersWithEventErrFvr;
  };
  useEffect(() => {
    applyFilters();
  }, [filterBy, searchValue, deviceData]);

  function downloadCSV(csv, filename) {
    var csvFile;
    var downloadLink;

    //define the file type to text/csv
    csvFile = new Blob([csv], { type: "text/csv" });
    downloadLink = document.createElement("a");
    downloadLink.download = filename;
    downloadLink.href = window.URL.createObjectURL(csvFile);
    downloadLink.style.display = "none";

    document.body.appendChild(downloadLink);
    downloadLink.click();
  }
  function exportTableToCSV() {
    //declare a JavaScript letiable of array type
    let csv = [];
    let rows = document.querySelectorAll("table tr");

    //merge the whole data in tabular form
    for (let i = 0; i < rows.length; i++) {
      let row = [],
        cols = rows[i].querySelectorAll("td, th");
      for (let j = 0; j < cols.length; j++) row.push(cols[j].innerText);
      csv.push(row.join(","));
    }
    //call the function to download the CSV file
    let filename = "Impadance";
    downloadCSV(csv.join("\n"), filename);
  }

 const getAllDevice = async (isBackground = false) => {
  try {
    const response = await deviceAllSessionAPI(100, null, "EVENT_TRT_IMP");
    const sessions = response?.sessions || [];
    const usersWithActiveStim = identifyUsersWithInactiveStim(sessions);
    impedanceCache.data = usersWithActiveStim;  // ← save to cache
    setDeviceData(usersWithActiveStim);
    if (!isBackground) {
      setSearchData(usersWithActiveStim);  // ← only on non-background
    }
  } catch (error) {
    console.error("Failed loading impedance data:", error);
    setDeviceData([]);
    setSearchData([]);
  } finally {
    setLoading(false);
    const btn = document.getElementById("refreshbtn");
    if (btn) btn.className = "fas fa-sync fa-stop";
  }
};

  const handleSort = (column) => {
    if (sortColumn === column) {
      // Toggle sorting order if the same column is clicked again
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortColumn(column);
      setSortOrder("asc");
    }
  };
  const deviceListRecords = () => {
    let sortedList = [...currentRecords];

    // Sorting the list based on the sortColumn and sortOrder
    if (sortColumn) {
      sortedList.sort((a, b) => {
        if (a?.data?.list && b?.data?.list) {
          if (sortOrder === "asc") {
            return a?.data?.list?.[sortColumn]
              ?.toString()
              .localeCompare(b?.data?.list?.[sortColumn]);
          } else {
            return b?.data?.list?.[sortColumn]
              ?.toString()
              .localeCompare(a?.data?.list?.[sortColumn]);
          }
        }
      });
    }

    // If loading is true, display the spinner
 if (loading) {
  return (
    <tr>
      <td colSpan="3" style={{ textAlign: "center", padding: "60px 0" }}>
        <Spinner animation="border" style={{ width: "2.5rem", height: "2.5rem", color: "#525f7f" }} />
        <div style={{ marginTop: 12, color: "#6c757d", fontSize: 14 }}>Loading...</div>
      </td>
    </tr>
  );
}


    // Check if there are no records at all
if (sortedList.length === 0) {
  return (
    <tr>
          <th colSpan="5" style={{ textAlign: "center" }}>
            No Record Found!
          </th>
    </tr>
  );
}

    // Filtering valid records
    const validRecords = sortedList.filter((user) => user?.data?.list !== null);

    // If no valid records, display "No Record Found!"
if (validRecords.length === 0) {
  return (
    <tr>
          <th colSpan="5" style={{ textAlign: "center" }}>
            No Record Found!
          </th>
    </tr>
  );
}

    // Mapping through valid records
    return validRecords.map((user, index) => {
  const handleClick = (event) => {
    event.preventDefault();
    history.push({
      pathname: `/device/${user?.data?.list?.deviceId}`,
    });
  };
      return (
        <tr key={index}>
          <td style={{ textAlign: "left" }}>
            <a href="#" onClick={handleClick}>
              {user?.data?.list?.prcId || "-"}
            </a>
          </td>
          <td style={{ textAlign: "left" }}>
            {user?.data?.list?.subjectId || "-"}
          </td>
          <td style={{ textAlign: "left" }}>{user.data.avgData || "-"}</td>
        </tr>
      );
    });
  };

useEffect(() => {
  if (impedanceCache.data) {
    setDeviceData(impedanceCache.data);
    setSearchData(impedanceCache.data);
    getAllDevice(true); // silent background refresh
  } else {
    getdata(); // first load with spinner
  }
}, []);
  return (
  <div style={{ display: "flex", flexDirection: "column", background: "#fff" }}>
    <TableHeader
  title="Impedance Summary"
  onRefresh={refreshlist}
  onDownload={exportTableToCSV}
  totalCount={searchData.length > 0 ? searchData.length : null}
  hasMore={false}
      filterContent={
  <div style={{ display: "flex", gap: 8, alignItems: "center", maxWidth: 500 }}>
    <Dropdown isOpen={isOpen} toggle={handleToggle} style={{ flexShrink: 0 }}>
      <DropdownToggle caret>Filter By: {filterBy}</DropdownToggle>
      <DropdownMenu>
        <DropdownItem onClick={() => handleFilterByChange("SubjectId")}>SubjectId</DropdownItem>
      </DropdownMenu>
    </Dropdown>
    <Input
      type="text"
      placeholder={`Enter ${filterBy}`}
      value={searchValue}
      onChange={handleSearchInputChange}
      style={{ flex: 1 }}
    />
  </div>
}
    />

    <div style={{ overflowY: "auto", background: "#fff" }}>
      <Table striped hover responsive bordered className="align-items-center table-flush" style={{ margin: 0 }}>
        <thead className="thead-light" style={{ cursor: "pointer", position: "sticky", top: 0, zIndex: 1 }}>
          <tr>
            <th scope="col" style={{ textAlign: "left" }} onClick={() => handleSort("prcId")}>Ring Id</th>
            <th scope="col" style={{ textAlign: "left" }} onClick={() => handleSort("subjectId")}>Subject Id</th>
            <th scope="col" style={{ textAlign: "left" }} onClick={() => handleSort("avgData")}>Average Impedance</th>
          </tr>
        </thead>
        <tbody>
          {deviceListRecords()}
          {searchData.length > 50 && !loading && (
            <tr>
              <td colSpan="3" style={{ textAlign: "right", padding: "12px 16px" }}>
                <div style={{ display: "inline-flex", gap: 8, alignItems: "center" }}>
                  <button disabled={currentPage === 1} onClick={() => setCurrentPage(prev => prev - 1)}
                    style={{ padding: "6px 14px", borderRadius: 6, border: "1px solid #dee2e6", background: currentPage === 1 ? "#f8f9fa" : "#fff", cursor: currentPage === 1 ? "not-allowed" : "pointer", fontWeight: 500 }}>←</button>
                  <div style={{ padding: "6px 14px", borderRadius: 6, background: "#f2f0f0", color: "#0e0d0d", fontWeight: 500, fontSize: 14 }}>
  {indexOfFirstRecord + 1}–{Math.min(indexOfLastRecord, searchData.length)} of {searchData.length}
</div>
                  <button disabled={currentPage === totalPages || totalPages === 0} onClick={() => setCurrentPage(prev => prev + 1)}
                    style={{ padding: "6px 14px", borderRadius: 6, border: "1px solid #dee2e6", background: currentPage === totalPages ? "#f8f9fa" : "#fff", cursor: currentPage === totalPages ? "not-allowed" : "pointer", fontWeight: 500 }}>→</button>
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  </div>
);
};

export default Impadance;
